// src/components/Services.js
import React from 'react';
import '../styles/Services.css'; // Criar um arquivo CSS para o estilo específico deste componente

// Importando os ícones que vamos usar
import { FaCarCrash, FaGasPump, FaTools, FaKey, FaTruckMoving, FaBatteryFull } from 'react-icons/fa';

// --- DADOS DOS SERVIÇOS ---
// Manter os dados aqui facilita a edição futura sem tocar no layout
const servicesData = [
  {
    icon: <FaTruckMoving />,
    title: 'Reboque de Veículos',
    description: 'Transporte seguro para carros, motos e utilitários, 24 horas por dia.'
  },
  {
    icon: <FaCarCrash />,
    title: 'Socorro em Caso de Acidente',
    description: 'Assistência completa para remoção do seu veículo em caso de colisão.'
  }
];


const Services = () => {
  return (
    <section id="services" className="services-container">
      <h2>Nossos Serviços</h2>
      <div className="services-grid">
        {servicesData.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Services;